import { render, staticRenderFns } from "./allocationRecord.vue?vue&type=template&id=1dc82e7b&scoped=true&"
import script from "./allocationRecord.vue?vue&type=script&lang=js&"
export * from "./allocationRecord.vue?vue&type=script&lang=js&"
import style0 from "./allocationRecord.vue?vue&type=style&index=0&id=1dc82e7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc82e7b",
  null
  
)

export default component.exports